<template>
  <el-dialog
    title="管理员详情"
    :visible="visible"
    width="600px"
    @close="handleClose"
  >
    <div v-if="adminData" class="admin-detail">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="管理员账号">
          {{ adminData.adminName }}
        </el-descriptions-item>

        <el-descriptions-item label="昵称">
          {{ adminData.nickName }}
        </el-descriptions-item>

        <el-descriptions-item label="邮箱">
          {{ adminData.email }}
        </el-descriptions-item>

        <el-descriptions-item label="手机号">
          {{ adminData.phone }}
        </el-descriptions-item>

        <el-descriptions-item label="状态">
          <el-tag :type="adminData.status === 0 ? 'success' : 'danger'">
            {{ adminData.status | statusText }}
          </el-tag>
        </el-descriptions-item>

        <el-descriptions-item label="权限" :span="2">
          <el-tag
            v-for="permission in adminData.permissions"
            :key="permission"
            style="margin-right: 8px; margin-bottom: 4px"
          >
            {{ permission | permissionText }}
          </el-tag>
        </el-descriptions-item>

        <el-descriptions-item label="管理用户数">
          {{ adminData.userCount || 0 }}
        </el-descriptions-item>

        <el-descriptions-item label="管理群组数">
          {{ adminData.groupCount || 0 }}
        </el-descriptions-item>

        <el-descriptions-item label="最后登录时间">
          {{ adminData.lastLoginTime | formatDate }}
        </el-descriptions-item>

        <el-descriptions-item label="最后登录IP">
          {{ adminData.lastLoginIp || "-" }}
        </el-descriptions-item>

        <el-descriptions-item label="创建时间">
          {{ adminData.createdTime | formatDate }}
        </el-descriptions-item>

        <el-descriptions-item label="更新时间">
          {{ adminData.updatedTime | formatDate }}
        </el-descriptions-item>

        <el-descriptions-item v-if="adminData.remark" label="备注" :span="2">
          {{ adminData.remark }}
        </el-descriptions-item>
      </el-descriptions>

      <!-- 操作日志 -->
      <div class="operation-logs" style="margin-top: 20px">
        <h4>最近操作记录</h4>
        <el-table :data="operationLogs" size="small">
          <el-table-column prop="operation" label="操作类型" width="120" />
          <el-table-column prop="target" label="操作对象" width="150" />
          <el-table-column prop="description" label="操作描述" />
          <el-table-column prop="createdTime" label="操作时间" width="150">
            <template slot-scope="scope">
              {{ scope.row.createdTime | formatDate }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getAdminOperationLogs } from "@/api/admin";

export default {
  name: "AdminDetail",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    adminData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      operationLogs: [],
    };
  },
  watch: {
    visible(val) {
      if (val && this.adminData) {
        this.loadOperationLogs();
      }
    },
  },
  methods: {
    async loadOperationLogs() {
      try {
        const response = await getAdminOperationLogs(this.adminData.id, {
          size: 10,
        });
        this.operationLogs = response.data || [];
      } catch (error) {
        console.error("加载操作日志失败:", error);
        // 模拟数据
        this.operationLogs = [
          {
            operation: "用户管理",
            target: "用户001",
            description: "禁用用户账号",
            createdTime: new Date().toISOString(),
          },
          {
            operation: "群组管理",
            target: "群组ABC",
            description: "解散群组",
            createdTime: new Date(Date.now() - 3600000).toISOString(),
          },
        ];
      }
    },

    handleClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.admin-detail {
  .operation-logs {
    h4 {
      margin-bottom: 10px;
      color: #303133;
    }
  }
}
</style>
